import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { useMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const PhoneSettingsStyleParts = [
  'vStack1',
  'text1',
  'text2',
  'text3',
  'extensionsContainer',
  'parkingContainer',
  'speedDialContainer',
  'vStack2',
  'text4',
  'phoneSettingsWrapper',
  'subheadingSection',
] as const
const helpers = createMultiStyleConfigHelpers(PhoneSettingsStyleParts)

const TextColor = 'fg.default'

export const PhoneSettingsStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    phoneSettingsWrapper: {
      width: '100%',
      height: '100%',
      padding: '1.875rem',
      flexDirection: 'column',
      gap: '1.25rem',
      overflowY: 'auto',
    },
    subheadingSection: {
      width: '100%',
      borderRadius: '0.25rem',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0.75rem',
      gap: '0.62rem',
      backgroundColor: 'bg.subtle',
    },
    vStack1: {
      w: 'full',
      gap: '1rem',
    },
    text1: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    text2: {
      ...textStyles[textStyleKeys.Body2],
    },
    text3: {
      ...textStyles[textStyleKeys.Body3_Bold],
    },
    extensionsContainer: {
      justifyContent: 'flex-start',
      width: '100%',
      height: '2.5rem',
      borderRadius: '0.5rem',
      border: '1.5px solid',
      borderColor: 'border.default',
      backgroundColor: 'bg.default',
      display: 'flex',
      padding: '4px 12px',
      alignItems: 'center',
      gap: '10px',
      alignSelf: 'stretch',
    },
    parkingContainer: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      height: '2.5rem',
      borderRadius: '0.5rem',
      border: '1.5px solid',
      borderColor: 'border.default',
      backgroundColor: 'bg.default',
      paddingX: '12px',
      gap: '0.62rem',
    },
    speedDialContainer: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      height: '62px',
      borderRadius: '0.5rem',
      border: '1.5px solid',
      backgroundColor: 'bg.default',
      borderColor: 'border.default',
      padding: '12px',
      gap: '0.62rem',
    },
    vStack2: {
      w: 'full',
      gap: '1.75rem',
    },
    text4: {
      textStyle: 'Body2',
      color: TextColor,
    },
  },
})
export const usePhoneSettingsStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(PhoneSettingsStyles, props) as MultiStyleType<
    typeof PhoneSettingsStyleParts
  >
}
